import { unavailableOnWeb } from './unavailableOnWeb.web';
export const create = unavailableOnWeb('Plaid create');
export const open = unavailableOnWeb('Plaid open');
